import { render, staticRenderFns } from "./ClampField.vue?vue&type=template&id=14607804&lang=pug&"
import script from "./ClampField.vue?vue&type=script&lang=js&"
export * from "./ClampField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports